import fetcher from "./fetcher";

const BASE_URL = "/api/position";

class Position {
  async list(queryParams = {}) {
    const queryString = new URLSearchParams(queryParams);

    const response = await fetcher.get(`${BASE_URL}?${queryString}`);

    return response.data;
  }

  async get(id) {
    const response = await fetcher.get(`${BASE_URL}/${id}`);

    return response.data;
  }

  async new(position) {
    const response = await fetcher.post(`${BASE_URL}`, position);

    return response.data;
  }

  async update(id, position) {
    const response = await fetcher.put(`${BASE_URL}/${id}`, position);

    return response.data;
  }

  async free(queryParams = {}) {
    const queryString = new URLSearchParams(queryParams);

    const response = await fetcher.get(`${BASE_URL}/free?${queryString}`);

    return response.data;
  }

  async occupied() {
    const response = await fetcher.get(`${BASE_URL}/occupied`);

    return response.data;
  }

  async room() {
    const response = await fetcher.get(`${BASE_URL}/room`);

    return response.data;
  }
}

export default new Position();
